/**
 * Created by Ning Jiang on 2017-10-12.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {MaskCreator} from "../../utils/MaskCreator";

export class DungeonQuestReelAreaView extends ReelAreaView {
    private _maskSprite:PIXI.Graphics;

    constructor() {
        super(ResourcesGroupName.MAIN);
    }

    protected initAnimations():void {
        this._maskSprite = MaskCreator.createSymbolAreaMaskGraphics(120, 0);
        this.addChild(this._maskSprite);
        this.mask = this._maskSprite;
    }
}